import { h } from "preact";
import { useContext } from "preact/hooks";
import { Context } from "../lib/globalState";

export default function LoadReplies({
  replies,
  loadReplies,
  loadingReplies,
  setLoadingReplies,
  repliesLoaded,
  toggle,
  setToggle,
}) {
  const {
    state: { reply },
  } = useContext(Context);

  // Don't show repl(ies) is it/they is/are disabled in widget settings
  if (!reply) {
    return null;
  }

  // Show it/them if they are enabled in widget settings
  if (replies) {
    const count = Object.values(replies).length;

    if (repliesLoaded) {
      return (
        <div className="d-flex" onClick={() => setToggle(!toggle)}>
          {toggle ? (
            <span className="show-hide-reply">
              {count} {count > 1 ? "Replies" : "Reply"}
            </span>
          ) : (
            <span className="show-hide-reply">
              Hide {count > 1 ? "Replies" : "Reply"}
            </span>
          )}
        </div>
      );
    }

    return (
      <div
        className="d-flex"
        onClick={() => {
          setLoadingReplies(!loadingReplies);
          loadReplies(true);
        }}
      >
        {!loadingReplies ? (
          <span className="show-hide-reply">
            {count} {count > 1 ? "Replies" : "Reply"}
          </span>
        ) : (
          <span className="loader-wrapper">
            <div className="lds-ellipsis" style="display: flex">
              <div />
              <div />
              <div />
              <div />
            </div>
          </span>
        )}
      </div>
    );
  }

  return null;
}
